import { ThunkAction } from 'redux-thunk';
import { Action } from 'redux';
import dateFormat from 'date-fns/format';
import {
  ADD_TO_BASKET,
  CLEAR_BASKET,
  FETCH_ORDERS_FAILURE,
  FETCH_ORDERS_REQUEST,
  FETCH_ORDERS_RESPONSE,
  Order,
  OrderActionTypes,
  OrderLine,
  PLACE_ORDER_FAILURE,
  PLACE_ORDER_REQUEST,
  PLACE_ORDER_RESPONSE,
  SoftOrder,
} from '../types/Order';

import { RootState } from '../store/configureStore';
import { getCustomerID, isAuthenticated } from '../helpers/functions';
import { getOrderHistory, postSalesOrder } from '../api/OrderApi';
import history from '../helpers/history';
import CONSTANTS from '../helpers/constants';
import c from '../helpers/constants';

export function addToBasketRequest(softOrder: SoftOrder): OrderActionTypes {
  return {
    type: ADD_TO_BASKET,
    payload: softOrder,
  };
}

export function clearBasketRequest(): OrderActionTypes {
  return {
    type: CLEAR_BASKET,
    payload: null,
  };
}


export function fetchOrdersRequest(): OrderActionTypes {
  return {
    type: FETCH_ORDERS_REQUEST,
    payload: null,
  };
}

export function fetchOrdersResponse(
  orders: Order[],
): OrderActionTypes {
  return {
    type: FETCH_ORDERS_RESPONSE,
    payload: orders,
  };
}

export function fetchOrdersFailure(): OrderActionTypes {
  return {
    type: FETCH_ORDERS_FAILURE,
    payload: null,
  };
}

export function placeOrdersRequest(): OrderActionTypes {
  return {
    type: PLACE_ORDER_REQUEST,
    payload: null,
  };
}

export function placeOrdersResponse(): OrderActionTypes {
  return {
    type: PLACE_ORDER_RESPONSE,
    payload: null,
  };
}

export function placeOrdersFailure(): OrderActionTypes {
  return {
    type: PLACE_ORDER_FAILURE,
    payload: null,
  };
}

export const addToBasket = (orderLines: OrderLine[]):
ThunkAction<void, RootState, unknown, Action<string>> =>
  async (dispatch, getState) => {
    const state = getState();
    const existingOrderLines = state.order.basket;
    const total = [...existingOrderLines, ...orderLines];
    const data = {
      orderlines: total.map(o => ({
        product_sku: o.product_sku,
        quantity: o.quantity,
        length: o.length,
        width: o.width,
        pallet_id: o.pallet_id,
        line_reference: o.line_reference,
        line_price: o.item_price,
        line_discount: o.line_discount,
        roll_id: o.roll_id,
        half_roll: o.half_roll,
      })),
      order_type: 'Soft',
      customer_id: getCustomerID(),
      delivery_date: dateFormat(Date.now(), 'dd/MM/yy'),
      customer_delivery_id: '01',
      special_instructions: 'none',
      order_reference: 'Ref',
    };
    const result = await postSalesOrder(data);
    const deliveryDates: string[] = result?.delivery_date?.map((o: any) => dateFormat(new Date(o.delivery_date), 'dd/MM/yy'));
    dispatch(addToBasketRequest({ orderLines, deliveryDates }));
  };

export const clearBasket = ():
ThunkAction<void, RootState, unknown, Action<string>> =>
  async (dispatch) => {
    dispatch(clearBasketRequest());
  };

export const placeOrder = ():
ThunkAction<void, RootState, unknown, Action<string>> =>
  async (dispatch, getState) => {
    const orderLines = getState().order.basket;
    if (!isAuthenticated()) {
      history.push(c.APP_ROUTES.LOGIN);
    }
    dispatch(placeOrdersRequest());
    const data = {
      orderlines: orderLines.map(o => ({
        product_sku: o.product_sku,
        quantity: o.quantity,
        length: o.length,
        width: o.width,
        pallet_id: o.pallet_id,
        line_reference: o.line_reference,
        line_price: o.item_price,
        line_discount: o.line_discount,
        roll_id: o.roll_id,
        half_roll: o.half_roll,
      })),
      order_type: 'Hard',
      customer_id: getCustomerID(),
      customer_delivery_id: '01',
      delivery_date: '27/01/2022',
      special_instructions: 'none',
      order_reference: 'Ref',
    };
    const asyncResp = await postSalesOrder(data);
    if (asyncResp.return_code === 'OK') {
      dispatch(placeOrdersResponse());
      dispatch(clearBasketRequest());
      // @ts-ignore
      history.push({
        pathname: CONSTANTS.APP_ROUTES.ORDER_CONFIRMATION,
        search: `orderNumber=${asyncResp?.order_number}`,
      });
    } else {
      dispatch(placeOrdersFailure());
    }
  };

export const fetchOrders = ():
ThunkAction<void, RootState, unknown, Action<string>> =>
  async (dispatch) => {
    dispatch(fetchOrdersRequest());
    if (!isAuthenticated()) {
      history.push(c.APP_ROUTES.LOGIN);
    }
    const asyncResp: any = await getOrderHistory(getCustomerID());
    if (asyncResp.return_code === 'OK') {
      await dispatch(fetchOrdersResponse(asyncResp.order_lines));
    } else {
      await dispatch(fetchOrdersFailure());
    }
  };
